import API from './api';

export const groupTripAnalyticsService = {
  async getAllAnalytics(startDate, endDate, groupId = null) {
    try {
      console.log('🔵 Calling Group Trip API with params:', { startDate, endDate, groupId });

      const params = { startDate, endDate };
      if (groupId) params.groupId = groupId;

      const response = await API.get('/api/trips/admin/group-analytics/all', { 
        params,
        timeout: 60000 // 60 seconds
      });

      console.log('🔵 API Response:', response);

      if (response.data && response.data.success && response.data.data) {
        return {
          success: true,
          data: response.data.data
        };
      }

      if (response.data && response.data.success === false) {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch group trip analytics'
        };
      }

      return {
        success: false,
        message: 'Unexpected response format from server'
      };

    } catch (error) {
      console.error('❌ Group Trip Analytics Service Error:', error);
      
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        return {
          success: false,
          message: 'Request timeout. Try a smaller date range.'
        };
      }
      
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to fetch group trip analytics',
        error: error.response?.data
      };
    }
  },

  async getMetrics(startDate, endDate, groupId = null) {
    try {
      const params = { startDate, endDate };
      if (groupId) params.groupId = groupId;

      const response = await API.get('/api/trips/admin/group-analytics/metrics', { 
        params,
        timeout: 60000 
      });
      
      if (response.data && response.data.success) {
        return { success: true, data: response.data.data };
      }
      
      return { 
        success: false, 
        message: response.data?.message || 'Failed to fetch metrics' 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch metrics'
      };
    }
  },

  async getAllGroups() {
    try {
      const response = await API.get('/api/trips/admin/group-analytics/groups', {
        timeout: 60000
      });
      
      if (response.data && response.data.success) {
        return { success: true, data: response.data.data };
      }
      
      return { 
        success: false, 
        message: response.data?.message || 'Failed to fetch groups' 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch groups'
      };
    }
  }
};

export default groupTripAnalyticsService;
